// Generated by Melange

import * as Buhta_kassaapis__Buhta_kassa_v1_types from "./buhta_kassa_v1_types.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_info from "./buhta_kassa_v1alpha1_kkm_info.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_timestamp from "../../third_party/google_wkt/gen/google_protobuf_timestamp.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report.ml",
      353,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReport"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportSection"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportBalance"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportOperation"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "ZxReportReceiptPayment"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportReceipt"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "ZxReportTaxOperation"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportTax"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportMoneyPlacement"
                    ]
                  ]
                },
                "V1alpha1"
              ]]
          },
          "Kassa"
        ]]
    });

const Kassa = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report.ml",
      668,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReport"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportSection"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportBalance"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportOperation"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportReceiptPayment"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportReceipt"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportTaxOperation"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportTax"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportMoneyPlacement"
              ]
            ]
          },
          "V1alpha1"
        ]]
    });

const V1alpha1 = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report.ml",
      981,
      10
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReport"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportSection"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportBalance"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportOperation"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportReceiptPayment"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportReceipt"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportTaxOperation"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportTax"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportMoneyPlacement"
        ]
      ]
    });

const ZxReport = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report.ml",
      1028,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ZxReportSection = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report.ml",
      1140,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ZxReportBalance = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report.ml",
      1204,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ZxReportOperation = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report.ml",
      1269,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ZxReportReceipt = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report.ml",
      1375,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportReceiptPayment"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ZxReportTax = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report.ml",
      1561,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportTaxOperation"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ZxReportMoneyPlacement = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report.ml",
      1699,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.kassa.v1alpha1.ZxReport";
}

function make(idOpt, serial_idOpt, report_typeOpt, report_time, shift_idOpt, shift_open_time, shift_close_time, org, kkm, opening_balancesOpt, shift_resultsOpt, cash_amountOpt, revenue_amountOpt, closing_balancesOpt, section_resultsOpt, receipt_resultsOpt, money_placement_resultsOpt, tax_resultsOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const serial_id = serial_idOpt !== undefined ? serial_idOpt : 0;
  const report_type = report_typeOpt !== undefined ? report_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.ReportType.from_int_exn, 0);
  const shift_id = shift_idOpt !== undefined ? shift_idOpt : 0;
  const opening_balances = opening_balancesOpt !== undefined ? opening_balancesOpt : /* [] */0;
  const shift_results = shift_resultsOpt !== undefined ? shift_resultsOpt : /* [] */0;
  const cash_amount = cash_amountOpt !== undefined ? cash_amountOpt : "";
  const revenue_amount = revenue_amountOpt !== undefined ? revenue_amountOpt : "";
  const closing_balances = closing_balancesOpt !== undefined ? closing_balancesOpt : /* [] */0;
  const section_results = section_resultsOpt !== undefined ? section_resultsOpt : /* [] */0;
  const receipt_results = receipt_resultsOpt !== undefined ? receipt_resultsOpt : /* [] */0;
  const money_placement_results = money_placement_resultsOpt !== undefined ? money_placement_resultsOpt : /* [] */0;
  const tax_results = tax_resultsOpt !== undefined ? tax_resultsOpt : /* [] */0;
  return {
          id: id,
          serial_id: serial_id,
          report_type: report_type,
          report_time: report_time,
          shift_id: shift_id,
          shift_open_time: shift_open_time,
          shift_close_time: shift_close_time,
          org: org,
          kkm: kkm,
          opening_balances: opening_balances,
          shift_results: shift_results,
          cash_amount: cash_amount,
          revenue_amount: revenue_amount,
          closing_balances: closing_balances,
          section_results: section_results,
          receipt_results: receipt_results,
          money_placement_results: money_placement_results,
          tax_results: tax_results
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_serial_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "serial_id",
            "serialId"
          ],
          Ocaml_protoc_plugin__Spec.int64_int,
          0
        ]));

const merge_report_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "report_type",
            "reportType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.ReportType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.ReportType.from_int_exn, 0)
        ]));

const $$let = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_report_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            4,
            "report_time",
            "reportTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

const merge_shift_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "shift_id",
            "shiftId"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const $$let$1 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_shift_open_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            6,
            "shift_open_time",
            "shiftOpenTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

const $$let$2 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_shift_close_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            7,
            "shift_close_time",
            "shiftCloseTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              })
        ]));

const $$let$3 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_info.Buhta.Kassa.V1alpha1.OrgInfo;

const merge_org = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            21,
            "org",
            "org"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

const $$let$4 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_info.Buhta.Kassa.V1alpha1.KkmInfo;

const merge_kkm = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            22,
            "kkm",
            "kkm"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$4.name,
                make: $$let$4.make,
                from_proto: $$let$4.from_proto,
                from_proto_exn: $$let$4.from_proto_exn,
                to_proto: $$let$4.to_proto,
                to_proto$p: $$let$4.to_proto$p,
                merge: $$let$4.merge,
                to_json: $$let$4.to_json,
                from_json_exn: $$let$4.from_json_exn,
                from_json: $$let$4.from_json
              })
        ]));

const merge_opening_balances = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            31,
            "opening_balances",
            "openingBalances"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ZxReportBalance.name,
                make: ZxReportBalance.make,
                from_proto: ZxReportBalance.from_proto,
                from_proto_exn: ZxReportBalance.from_proto_exn,
                to_proto: ZxReportBalance.to_proto,
                to_proto$p: ZxReportBalance.to_proto$p,
                merge: ZxReportBalance.merge,
                to_json: ZxReportBalance.to_json,
                from_json_exn: ZxReportBalance.from_json_exn,
                from_json: ZxReportBalance.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

const merge_shift_results = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            32,
            "shift_results",
            "shiftResults"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ZxReportOperation.name,
                make: ZxReportOperation.make,
                from_proto: ZxReportOperation.from_proto,
                from_proto_exn: ZxReportOperation.from_proto_exn,
                to_proto: ZxReportOperation.to_proto,
                to_proto$p: ZxReportOperation.to_proto$p,
                merge: ZxReportOperation.merge,
                to_json: ZxReportOperation.to_json,
                from_json_exn: ZxReportOperation.from_json_exn,
                from_json: ZxReportOperation.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

const merge_cash_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            33,
            "cash_amount",
            "cashAmount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_revenue_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            34,
            "revenue_amount",
            "revenueAmount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_closing_balances = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            35,
            "closing_balances",
            "closingBalances"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ZxReportBalance.name,
                make: ZxReportBalance.make,
                from_proto: ZxReportBalance.from_proto,
                from_proto_exn: ZxReportBalance.from_proto_exn,
                to_proto: ZxReportBalance.to_proto,
                to_proto$p: ZxReportBalance.to_proto$p,
                merge: ZxReportBalance.merge,
                to_json: ZxReportBalance.to_json,
                from_json_exn: ZxReportBalance.from_json_exn,
                from_json: ZxReportBalance.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

const merge_section_results = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            41,
            "section_results",
            "sectionResults"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ZxReportSection.name,
                make: ZxReportSection.make,
                from_proto: ZxReportSection.from_proto,
                from_proto_exn: ZxReportSection.from_proto_exn,
                to_proto: ZxReportSection.to_proto,
                to_proto$p: ZxReportSection.to_proto$p,
                merge: ZxReportSection.merge,
                to_json: ZxReportSection.to_json,
                from_json_exn: ZxReportSection.from_json_exn,
                from_json: ZxReportSection.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

const merge_receipt_results = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            42,
            "receipt_results",
            "receiptResults"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ZxReportReceipt.name,
                make: ZxReportReceipt.make,
                from_proto: ZxReportReceipt.from_proto,
                from_proto_exn: ZxReportReceipt.from_proto_exn,
                to_proto: ZxReportReceipt.to_proto,
                to_proto$p: ZxReportReceipt.to_proto$p,
                merge: ZxReportReceipt.merge,
                to_json: ZxReportReceipt.to_json,
                from_json_exn: ZxReportReceipt.from_json_exn,
                from_json: ZxReportReceipt.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

const merge_money_placement_results = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            43,
            "money_placement_results",
            "moneyPlacementResults"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ZxReportMoneyPlacement.name,
                make: ZxReportMoneyPlacement.make,
                from_proto: ZxReportMoneyPlacement.from_proto,
                from_proto_exn: ZxReportMoneyPlacement.from_proto_exn,
                to_proto: ZxReportMoneyPlacement.to_proto,
                to_proto$p: ZxReportMoneyPlacement.to_proto$p,
                merge: ZxReportMoneyPlacement.merge,
                to_json: ZxReportMoneyPlacement.to_json,
                from_json_exn: ZxReportMoneyPlacement.from_json_exn,
                from_json: ZxReportMoneyPlacement.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

const merge_tax_results = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            44,
            "tax_results",
            "taxResults"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ZxReportTax.name,
                make: ZxReportTax.make,
                from_proto: ZxReportTax.from_proto,
                from_proto_exn: ZxReportTax.from_proto_exn,
                to_proto: ZxReportTax.to_proto,
                to_proto$p: ZxReportTax.to_proto$p,
                merge: ZxReportTax.merge,
                to_json: ZxReportTax.to_json,
                from_json_exn: ZxReportTax.from_json_exn,
                from_json: ZxReportTax.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          serial_id: Curry._2(merge_serial_id, t1.serial_id, t2.serial_id),
          report_type: Curry._2(merge_report_type, t1.report_type, t2.report_type),
          report_time: Curry._2(merge_report_time, t1.report_time, t2.report_time),
          shift_id: Curry._2(merge_shift_id, t1.shift_id, t2.shift_id),
          shift_open_time: Curry._2(merge_shift_open_time, t1.shift_open_time, t2.shift_open_time),
          shift_close_time: Curry._2(merge_shift_close_time, t1.shift_close_time, t2.shift_close_time),
          org: Curry._2(merge_org, t1.org, t2.org),
          kkm: Curry._2(merge_kkm, t1.kkm, t2.kkm),
          opening_balances: Curry._2(merge_opening_balances, t1.opening_balances, t2.opening_balances),
          shift_results: Curry._2(merge_shift_results, t1.shift_results, t2.shift_results),
          cash_amount: Curry._2(merge_cash_amount, t1.cash_amount, t2.cash_amount),
          revenue_amount: Curry._2(merge_revenue_amount, t1.revenue_amount, t2.revenue_amount),
          closing_balances: Curry._2(merge_closing_balances, t1.closing_balances, t2.closing_balances),
          section_results: Curry._2(merge_section_results, t1.section_results, t2.section_results),
          receipt_results: Curry._2(merge_receipt_results, t1.receipt_results, t2.receipt_results),
          money_placement_results: Curry._2(merge_money_placement_results, t1.money_placement_results, t2.money_placement_results),
          tax_results: Curry._2(merge_tax_results, t1.tax_results, t2.tax_results)
        };
}

function spec(param) {
  const $$let = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$1 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$2 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$3 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_info.Buhta.Kassa.V1alpha1.OrgInfo;
  const $$let$4 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_info.Buhta.Kassa.V1alpha1.KkmInfo;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "serial_id",
                        "serialId"
                      ],
                      Ocaml_protoc_plugin__Spec.int64_int,
                      0
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "report_type",
                            "reportType"
                          ],
                          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.ReportType),
                          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.ReportType.from_int_exn, 0)
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                              [
                                4,
                                "report_time",
                                "reportTime"
                              ],
                              Ocaml_protoc_plugin__Spec.message({
                                    name: $$let.name,
                                    make: $$let.make,
                                    from_proto: $$let.from_proto,
                                    from_proto_exn: $$let.from_proto_exn,
                                    to_proto: $$let.to_proto,
                                    to_proto$p: $$let.to_proto$p,
                                    merge: $$let.merge,
                                    to_json: $$let.to_json,
                                    from_json_exn: $$let.from_json_exn,
                                    from_json: $$let.from_json
                                  })
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    5,
                                    "shift_id",
                                    "shiftId"
                                  ],
                                  Ocaml_protoc_plugin__Spec.int32_int,
                                  0
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                      [
                                        6,
                                        "shift_open_time",
                                        "shiftOpenTime"
                                      ],
                                      Ocaml_protoc_plugin__Spec.message({
                                            name: $$let$1.name,
                                            make: $$let$1.make,
                                            from_proto: $$let$1.from_proto,
                                            from_proto_exn: $$let$1.from_proto_exn,
                                            to_proto: $$let$1.to_proto,
                                            to_proto$p: $$let$1.to_proto$p,
                                            merge: $$let$1.merge,
                                            to_json: $$let$1.to_json,
                                            from_json_exn: $$let$1.from_json_exn,
                                            from_json: $$let$1.from_json
                                          })
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                          [
                                            7,
                                            "shift_close_time",
                                            "shiftCloseTime"
                                          ],
                                          Ocaml_protoc_plugin__Spec.message({
                                                name: $$let$2.name,
                                                make: $$let$2.make,
                                                from_proto: $$let$2.from_proto,
                                                from_proto_exn: $$let$2.from_proto_exn,
                                                to_proto: $$let$2.to_proto,
                                                to_proto$p: $$let$2.to_proto$p,
                                                merge: $$let$2.merge,
                                                to_json: $$let$2.to_json,
                                                from_json_exn: $$let$2.from_json_exn,
                                                from_json: $$let$2.from_json
                                              })
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                              [
                                                21,
                                                "org",
                                                "org"
                                              ],
                                              Ocaml_protoc_plugin__Spec.message({
                                                    name: $$let$3.name,
                                                    make: $$let$3.make,
                                                    from_proto: $$let$3.from_proto,
                                                    from_proto_exn: $$let$3.from_proto_exn,
                                                    to_proto: $$let$3.to_proto,
                                                    to_proto$p: $$let$3.to_proto$p,
                                                    merge: $$let$3.merge,
                                                    to_json: $$let$3.to_json,
                                                    from_json_exn: $$let$3.from_json_exn,
                                                    from_json: $$let$3.from_json
                                                  })
                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                  [
                                                    22,
                                                    "kkm",
                                                    "kkm"
                                                  ],
                                                  Ocaml_protoc_plugin__Spec.message({
                                                        name: $$let$4.name,
                                                        make: $$let$4.make,
                                                        from_proto: $$let$4.from_proto,
                                                        from_proto_exn: $$let$4.from_proto_exn,
                                                        to_proto: $$let$4.to_proto,
                                                        to_proto$p: $$let$4.to_proto$p,
                                                        merge: $$let$4.merge,
                                                        to_json: $$let$4.to_json,
                                                        from_json_exn: $$let$4.from_json_exn,
                                                        from_json: $$let$4.from_json
                                                      })
                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                                      [
                                                        31,
                                                        "opening_balances",
                                                        "openingBalances"
                                                      ],
                                                      Ocaml_protoc_plugin__Spec.message({
                                                            name: ZxReportBalance.name,
                                                            make: ZxReportBalance.make,
                                                            from_proto: ZxReportBalance.from_proto,
                                                            from_proto_exn: ZxReportBalance.from_proto_exn,
                                                            to_proto: ZxReportBalance.to_proto,
                                                            to_proto$p: ZxReportBalance.to_proto$p,
                                                            merge: ZxReportBalance.merge,
                                                            to_json: ZxReportBalance.to_json,
                                                            from_json_exn: ZxReportBalance.from_json_exn,
                                                            from_json: ZxReportBalance.from_json
                                                          }),
                                                      Ocaml_protoc_plugin__Spec.not_packed
                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                                          [
                                                            32,
                                                            "shift_results",
                                                            "shiftResults"
                                                          ],
                                                          Ocaml_protoc_plugin__Spec.message({
                                                                name: ZxReportOperation.name,
                                                                make: ZxReportOperation.make,
                                                                from_proto: ZxReportOperation.from_proto,
                                                                from_proto_exn: ZxReportOperation.from_proto_exn,
                                                                to_proto: ZxReportOperation.to_proto,
                                                                to_proto$p: ZxReportOperation.to_proto$p,
                                                                merge: ZxReportOperation.merge,
                                                                to_json: ZxReportOperation.to_json,
                                                                from_json_exn: ZxReportOperation.from_json_exn,
                                                                from_json: ZxReportOperation.from_json
                                                              }),
                                                          Ocaml_protoc_plugin__Spec.not_packed
                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                              [
                                                                33,
                                                                "cash_amount",
                                                                "cashAmount"
                                                              ],
                                                              Ocaml_protoc_plugin__Spec.string,
                                                              ""
                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                  [
                                                                    34,
                                                                    "revenue_amount",
                                                                    "revenueAmount"
                                                                  ],
                                                                  Ocaml_protoc_plugin__Spec.string,
                                                                  ""
                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                                                      [
                                                                        35,
                                                                        "closing_balances",
                                                                        "closingBalances"
                                                                      ],
                                                                      Ocaml_protoc_plugin__Spec.message({
                                                                            name: ZxReportBalance.name,
                                                                            make: ZxReportBalance.make,
                                                                            from_proto: ZxReportBalance.from_proto,
                                                                            from_proto_exn: ZxReportBalance.from_proto_exn,
                                                                            to_proto: ZxReportBalance.to_proto,
                                                                            to_proto$p: ZxReportBalance.to_proto$p,
                                                                            merge: ZxReportBalance.merge,
                                                                            to_json: ZxReportBalance.to_json,
                                                                            from_json_exn: ZxReportBalance.from_json_exn,
                                                                            from_json: ZxReportBalance.from_json
                                                                          }),
                                                                      Ocaml_protoc_plugin__Spec.not_packed
                                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                                                          [
                                                                            41,
                                                                            "section_results",
                                                                            "sectionResults"
                                                                          ],
                                                                          Ocaml_protoc_plugin__Spec.message({
                                                                                name: ZxReportSection.name,
                                                                                make: ZxReportSection.make,
                                                                                from_proto: ZxReportSection.from_proto,
                                                                                from_proto_exn: ZxReportSection.from_proto_exn,
                                                                                to_proto: ZxReportSection.to_proto,
                                                                                to_proto$p: ZxReportSection.to_proto$p,
                                                                                merge: ZxReportSection.merge,
                                                                                to_json: ZxReportSection.to_json,
                                                                                from_json_exn: ZxReportSection.from_json_exn,
                                                                                from_json: ZxReportSection.from_json
                                                                              }),
                                                                          Ocaml_protoc_plugin__Spec.not_packed
                                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                                                              [
                                                                                42,
                                                                                "receipt_results",
                                                                                "receiptResults"
                                                                              ],
                                                                              Ocaml_protoc_plugin__Spec.message({
                                                                                    name: ZxReportReceipt.name,
                                                                                    make: ZxReportReceipt.make,
                                                                                    from_proto: ZxReportReceipt.from_proto,
                                                                                    from_proto_exn: ZxReportReceipt.from_proto_exn,
                                                                                    to_proto: ZxReportReceipt.to_proto,
                                                                                    to_proto$p: ZxReportReceipt.to_proto$p,
                                                                                    merge: ZxReportReceipt.merge,
                                                                                    to_json: ZxReportReceipt.to_json,
                                                                                    from_json_exn: ZxReportReceipt.from_json_exn,
                                                                                    from_json: ZxReportReceipt.from_json
                                                                                  }),
                                                                              Ocaml_protoc_plugin__Spec.not_packed
                                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                                                                  [
                                                                                    43,
                                                                                    "money_placement_results",
                                                                                    "moneyPlacementResults"
                                                                                  ],
                                                                                  Ocaml_protoc_plugin__Spec.message({
                                                                                        name: ZxReportMoneyPlacement.name,
                                                                                        make: ZxReportMoneyPlacement.make,
                                                                                        from_proto: ZxReportMoneyPlacement.from_proto,
                                                                                        from_proto_exn: ZxReportMoneyPlacement.from_proto_exn,
                                                                                        to_proto: ZxReportMoneyPlacement.to_proto,
                                                                                        to_proto$p: ZxReportMoneyPlacement.to_proto$p,
                                                                                        merge: ZxReportMoneyPlacement.merge,
                                                                                        to_json: ZxReportMoneyPlacement.to_json,
                                                                                        from_json_exn: ZxReportMoneyPlacement.from_json_exn,
                                                                                        from_json: ZxReportMoneyPlacement.from_json
                                                                                      }),
                                                                                  Ocaml_protoc_plugin__Spec.not_packed
                                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                                                                      [
                                                                                        44,
                                                                                        "tax_results",
                                                                                        "taxResults"
                                                                                      ],
                                                                                      Ocaml_protoc_plugin__Spec.message({
                                                                                            name: ZxReportTax.name,
                                                                                            make: ZxReportTax.make,
                                                                                            from_proto: ZxReportTax.from_proto,
                                                                                            from_proto_exn: ZxReportTax.from_proto_exn,
                                                                                            to_proto: ZxReportTax.to_proto,
                                                                                            to_proto$p: ZxReportTax.to_proto$p,
                                                                                            merge: ZxReportTax.merge,
                                                                                            to_json: ZxReportTax.to_json,
                                                                                            from_json_exn: ZxReportTax.from_json_exn,
                                                                                            from_json: ZxReportTax.from_json
                                                                                          }),
                                                                                      Ocaml_protoc_plugin__Spec.not_packed
                                                                                    ]), Ocaml_protoc_plugin__Spec.nil))))))))))))))))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry.app(serialize, [
        writer,
        param.id,
        param.serial_id,
        param.report_type,
        param.report_time,
        param.shift_id,
        param.shift_open_time,
        param.shift_close_time,
        param.org,
        param.kkm,
        param.opening_balances,
        param.shift_results,
        param.cash_amount,
        param.revenue_amount,
        param.closing_balances,
        param.section_results,
        param.receipt_results,
        param.money_placement_results,
        param.tax_results
      ]);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, serial_id, report_type, report_time, shift_id, shift_open_time, shift_close_time, org, kkm, opening_balances, shift_results, cash_amount, revenue_amount, closing_balances, section_results, receipt_results, money_placement_results, tax_results) {
  return {
          id: id,
          serial_id: serial_id,
          report_type: report_type,
          report_time: report_time,
          shift_id: shift_id,
          shift_open_time: shift_open_time,
          shift_close_time: shift_close_time,
          org: org,
          kkm: kkm,
          opening_balances: opening_balances,
          shift_results: shift_results,
          cash_amount: cash_amount,
          revenue_amount: revenue_amount,
          closing_balances: closing_balances,
          section_results: section_results,
          receipt_results: receipt_results,
          money_placement_results: money_placement_results,
          tax_results: tax_results
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ZxReport", spec(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
                param.id,
                param.serial_id,
                param.report_type,
                param.report_time,
                param.shift_id,
                param.shift_open_time,
                param.shift_close_time,
                param.org,
                param.kkm,
                param.opening_balances,
                param.shift_results,
                param.cash_amount,
                param.revenue_amount,
                param.closing_balances,
                param.section_results,
                param.receipt_results,
                param.money_placement_results,
                param.tax_results
              ]);
  };
}

function constructor$1(id, serial_id, report_type, report_time, shift_id, shift_open_time, shift_close_time, org, kkm, opening_balances, shift_results, cash_amount, revenue_amount, closing_balances, section_results, receipt_results, money_placement_results, tax_results) {
  return {
          id: id,
          serial_id: serial_id,
          report_type: report_type,
          report_time: report_time,
          shift_id: shift_id,
          shift_open_time: shift_open_time,
          shift_close_time: shift_close_time,
          org: org,
          kkm: kkm,
          opening_balances: opening_balances,
          shift_results: shift_results,
          cash_amount: cash_amount,
          revenue_amount: revenue_amount,
          closing_balances: closing_balances,
          section_results: section_results,
          receipt_results: receipt_results,
          money_placement_results: money_placement_results,
          tax_results: tax_results
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ZxReport", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ZxReport, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.kassa.v1alpha1.ZxReportSection";
}

function make$1(section_codeOpt, operationsOpt, param) {
  const section_code = section_codeOpt !== undefined ? section_codeOpt : "";
  const operations = operationsOpt !== undefined ? operationsOpt : /* [] */0;
  return {
          section_code: section_code,
          operations: operations
        };
}

const merge_section_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "section_code",
            "sectionCode"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_operations = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            2,
            "operations",
            "operations"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ZxReportOperation.name,
                make: ZxReportOperation.make,
                from_proto: ZxReportOperation.from_proto,
                from_proto_exn: ZxReportOperation.from_proto_exn,
                to_proto: ZxReportOperation.to_proto,
                to_proto$p: ZxReportOperation.to_proto$p,
                merge: ZxReportOperation.merge,
                to_json: ZxReportOperation.to_json,
                from_json_exn: ZxReportOperation.from_json_exn,
                from_json: ZxReportOperation.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$1(t1, t2) {
  return {
          section_code: Curry._2(merge_section_code, t1.section_code, t2.section_code),
          operations: Curry._2(merge_operations, t1.operations, t2.operations)
        };
}

function spec$1(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "section_code",
                    "sectionCode"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                      [
                        2,
                        "operations",
                        "operations"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: ZxReportOperation.name,
                            make: ZxReportOperation.make,
                            from_proto: ZxReportOperation.from_proto,
                            from_proto_exn: ZxReportOperation.from_proto_exn,
                            to_proto: ZxReportOperation.to_proto,
                            to_proto$p: ZxReportOperation.to_proto$p,
                            merge: ZxReportOperation.merge,
                            to_json: ZxReportOperation.to_json,
                            from_json_exn: ZxReportOperation.from_json_exn,
                            from_json: ZxReportOperation.from_json
                          }),
                      Ocaml_protoc_plugin__Spec.not_packed
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._3(serialize$1, writer, param.section_code, param.operations);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(section_code, operations) {
  return {
          section_code: section_code,
          operations: operations
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ZxReportSection", spec$1(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.section_code, param.operations);
  };
}

function constructor$3(section_code, operations) {
  return {
          section_code: section_code,
          operations: operations
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ZxReportSection", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ZxReportSection, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.kassa.v1alpha1.ZxReportBalance";
}

function make$2(operation_typeOpt, amountOpt, param) {
  const operation_type = operation_typeOpt !== undefined ? operation_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0);
  const amount = amountOpt !== undefined ? amountOpt : "";
  return {
          operation_type: operation_type,
          amount: amount
        };
}

const merge_operation_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "operation_type",
            "operationType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0)
        ]));

const merge_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "amount",
            "amount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$2(t1, t2) {
  return {
          operation_type: Curry._2(merge_operation_type, t1.operation_type, t2.operation_type),
          amount: Curry._2(merge_amount, t1.amount, t2.amount)
        };
}

function spec$2(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "operation_type",
                    "operationType"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType),
                  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "amount",
                        "amount"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._3(serialize$2, writer, param.operation_type, param.amount);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(operation_type, amount) {
  return {
          operation_type: operation_type,
          amount: amount
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ZxReportBalance", spec$2(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.operation_type, param.amount);
  };
}

function constructor$5(operation_type, amount) {
  return {
          operation_type: operation_type,
          amount: amount
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ZxReportBalance", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ZxReportBalance, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.kassa.v1alpha1.ZxReportOperation";
}

function make$3(operation_typeOpt, countOpt, amountOpt, param) {
  const operation_type = operation_typeOpt !== undefined ? operation_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0);
  const count = countOpt !== undefined ? countOpt : 0;
  const amount = amountOpt !== undefined ? amountOpt : "";
  return {
          operation_type: operation_type,
          count: count,
          amount: amount
        };
}

const merge_operation_type$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "operation_type",
            "operationType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0)
        ]));

const merge_count = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "count",
            "count"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_amount$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "amount",
            "amount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$3(t1, t2) {
  return {
          operation_type: Curry._2(merge_operation_type$1, t1.operation_type, t2.operation_type),
          count: Curry._2(merge_count, t1.count, t2.count),
          amount: Curry._2(merge_amount$1, t1.amount, t2.amount)
        };
}

function spec$3(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "operation_type",
                    "operationType"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType),
                  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "count",
                        "count"
                      ],
                      Ocaml_protoc_plugin__Spec.int32_int,
                      0
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "amount",
                            "amount"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._4(serialize$3, writer, param.operation_type, param.count, param.amount);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(operation_type, count, amount) {
  return {
          operation_type: operation_type,
          count: count,
          amount: amount
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ZxReportOperation", spec$3(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.operation_type, param.count, param.amount);
  };
}

function constructor$7(operation_type, count, amount) {
  return {
          operation_type: operation_type,
          count: count,
          amount: amount
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ZxReportOperation", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ZxReportOperation, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

const ZxReportReceiptPayment = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report.ml",
      1408,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name$4(param) {
  return ".buhta.kassa.v1alpha1.ZxReportReceipt.ZxReportReceiptPayment";
}

function make$4(payment_typeOpt, countOpt, amountOpt, param) {
  const payment_type = payment_typeOpt !== undefined ? payment_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType.from_int_exn, 0);
  const count = countOpt !== undefined ? countOpt : 0;
  const amount = amountOpt !== undefined ? amountOpt : "";
  return {
          payment_type: payment_type,
          count: count,
          amount: amount
        };
}

const merge_payment_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "payment_type",
            "paymentType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType.from_int_exn, 0)
        ]));

const merge_count$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "count",
            "count"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_amount$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "amount",
            "amount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$4(t1, t2) {
  return {
          payment_type: Curry._2(merge_payment_type, t1.payment_type, t2.payment_type),
          count: Curry._2(merge_count$1, t1.count, t2.count),
          amount: Curry._2(merge_amount$2, t1.amount, t2.amount)
        };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "payment_type",
                    "paymentType"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType),
                  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "count",
                        "count"
                      ],
                      Ocaml_protoc_plugin__Spec.int32_int,
                      0
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "amount",
                            "amount"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
    });

function to_proto$p$4(writer, param) {
  Curry._4(serialize$4, writer, param.payment_type, param.count, param.amount);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(payment_type, count, amount) {
  return {
          payment_type: payment_type,
          count: count,
          amount: amount
        };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
    });

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$4, writer);
            });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ZxReportReceipt.ZxReportReceiptPayment", spec$4(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.payment_type, param.count, param.amount);
  };
}

function constructor$9(payment_type, count, amount) {
  return {
          payment_type: payment_type,
          count: count,
          amount: amount
        };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ZxReportReceipt.ZxReportReceiptPayment", spec$4(undefined), constructor$9);
    });

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$4, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ZxReportReceiptPayment, {
      make: make$4,
      to_proto: to_proto$4,
      from_proto: from_proto$4,
      to_json: to_json$4,
      from_json: from_json$4,
      name: name$4,
      merge: merge$4,
      to_proto$p: to_proto$p$4,
      from_proto_exn: from_proto_exn$4,
      from_json_exn: from_json_exn$4
    });

function name$5(param) {
  return ".buhta.kassa.v1alpha1.ZxReportReceipt";
}

function make$5(operation_typeOpt, countOpt, count_offlineOpt, count_totalOpt, amountOpt, amount_discountOpt, amount_markupOpt, amount_changeOpt, paymentsOpt, param) {
  const operation_type = operation_typeOpt !== undefined ? operation_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0);
  const count = countOpt !== undefined ? countOpt : 0;
  const count_offline = count_offlineOpt !== undefined ? count_offlineOpt : 0;
  const count_total = count_totalOpt !== undefined ? count_totalOpt : 0;
  const amount = amountOpt !== undefined ? amountOpt : "";
  const amount_discount = amount_discountOpt !== undefined ? amount_discountOpt : "";
  const amount_markup = amount_markupOpt !== undefined ? amount_markupOpt : "";
  const amount_change = amount_changeOpt !== undefined ? amount_changeOpt : "";
  const payments = paymentsOpt !== undefined ? paymentsOpt : /* [] */0;
  return {
          operation_type: operation_type,
          count: count,
          count_offline: count_offline,
          count_total: count_total,
          amount: amount,
          amount_discount: amount_discount,
          amount_markup: amount_markup,
          amount_change: amount_change,
          payments: payments
        };
}

const merge_operation_type$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "operation_type",
            "operationType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0)
        ]));

const merge_count$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "count",
            "count"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_count_offline = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "count_offline",
            "countOffline"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_count_total = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "count_total",
            "countTotal"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_amount$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "amount",
            "amount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_amount_discount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            6,
            "amount_discount",
            "amountDiscount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_amount_markup = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            7,
            "amount_markup",
            "amountMarkup"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_amount_change = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            8,
            "amount_change",
            "amountChange"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_payments = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            9,
            "payments",
            "payments"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ZxReportReceiptPayment.name,
                make: ZxReportReceiptPayment.make,
                from_proto: ZxReportReceiptPayment.from_proto,
                from_proto_exn: ZxReportReceiptPayment.from_proto_exn,
                to_proto: ZxReportReceiptPayment.to_proto,
                to_proto$p: ZxReportReceiptPayment.to_proto$p,
                merge: ZxReportReceiptPayment.merge,
                to_json: ZxReportReceiptPayment.to_json,
                from_json_exn: ZxReportReceiptPayment.from_json_exn,
                from_json: ZxReportReceiptPayment.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$5(t1, t2) {
  return {
          operation_type: Curry._2(merge_operation_type$2, t1.operation_type, t2.operation_type),
          count: Curry._2(merge_count$2, t1.count, t2.count),
          count_offline: Curry._2(merge_count_offline, t1.count_offline, t2.count_offline),
          count_total: Curry._2(merge_count_total, t1.count_total, t2.count_total),
          amount: Curry._2(merge_amount$3, t1.amount, t2.amount),
          amount_discount: Curry._2(merge_amount_discount, t1.amount_discount, t2.amount_discount),
          amount_markup: Curry._2(merge_amount_markup, t1.amount_markup, t2.amount_markup),
          amount_change: Curry._2(merge_amount_change, t1.amount_change, t2.amount_change),
          payments: Curry._2(merge_payments, t1.payments, t2.payments)
        };
}

function spec$5(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "operation_type",
                    "operationType"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType),
                  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "count",
                        "count"
                      ],
                      Ocaml_protoc_plugin__Spec.int32_int,
                      0
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "count_offline",
                            "countOffline"
                          ],
                          Ocaml_protoc_plugin__Spec.int32_int,
                          0
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "count_total",
                                "countTotal"
                              ],
                              Ocaml_protoc_plugin__Spec.int32_int,
                              0
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    5,
                                    "amount",
                                    "amount"
                                  ],
                                  Ocaml_protoc_plugin__Spec.string,
                                  ""
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                      [
                                        6,
                                        "amount_discount",
                                        "amountDiscount"
                                      ],
                                      Ocaml_protoc_plugin__Spec.string,
                                      ""
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                          [
                                            7,
                                            "amount_markup",
                                            "amountMarkup"
                                          ],
                                          Ocaml_protoc_plugin__Spec.string,
                                          ""
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                              [
                                                8,
                                                "amount_change",
                                                "amountChange"
                                              ],
                                              Ocaml_protoc_plugin__Spec.string,
                                              ""
                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                                  [
                                                    9,
                                                    "payments",
                                                    "payments"
                                                  ],
                                                  Ocaml_protoc_plugin__Spec.message({
                                                        name: ZxReportReceiptPayment.name,
                                                        make: ZxReportReceiptPayment.make,
                                                        from_proto: ZxReportReceiptPayment.from_proto,
                                                        from_proto_exn: ZxReportReceiptPayment.from_proto_exn,
                                                        to_proto: ZxReportReceiptPayment.to_proto,
                                                        to_proto$p: ZxReportReceiptPayment.to_proto$p,
                                                        merge: ZxReportReceiptPayment.merge,
                                                        to_json: ZxReportReceiptPayment.to_json,
                                                        from_json_exn: ZxReportReceiptPayment.from_json_exn,
                                                        from_json: ZxReportReceiptPayment.from_json
                                                      }),
                                                  Ocaml_protoc_plugin__Spec.not_packed
                                                ]), Ocaml_protoc_plugin__Spec.nil)))))))));
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
    });

function to_proto$p$5(writer, param) {
  Curry.app(serialize$5, [
        writer,
        param.operation_type,
        param.count,
        param.count_offline,
        param.count_total,
        param.amount,
        param.amount_discount,
        param.amount_markup,
        param.amount_change,
        param.payments
      ]);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(operation_type, count, count_offline, count_total, amount, amount_discount, amount_markup, amount_change, payments) {
  return {
          operation_type: operation_type,
          count: count,
          count_offline: count_offline,
          count_total: count_total,
          amount: amount,
          amount_discount: amount_discount,
          amount_markup: amount_markup,
          amount_change: amount_change,
          payments: payments
        };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
    });

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$5, writer);
            });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ZxReportReceipt", spec$5(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
                param.operation_type,
                param.count,
                param.count_offline,
                param.count_total,
                param.amount,
                param.amount_discount,
                param.amount_markup,
                param.amount_change,
                param.payments
              ]);
  };
}

function constructor$11(operation_type, count, count_offline, count_total, amount, amount_discount, amount_markup, amount_change, payments) {
  return {
          operation_type: operation_type,
          count: count,
          count_offline: count_offline,
          count_total: count_total,
          amount: amount,
          amount_discount: amount_discount,
          amount_markup: amount_markup,
          amount_change: amount_change,
          payments: payments
        };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ZxReportReceipt", spec$5(undefined), constructor$11);
    });

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$5, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportReceiptPayment"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ZxReportReceipt, {
      ZxReportReceiptPayment: ZxReportReceiptPayment,
      make: make$5,
      to_proto: to_proto$5,
      from_proto: from_proto$5,
      to_json: to_json$5,
      from_json: from_json$5,
      name: name$5,
      merge: merge$5,
      to_proto$p: to_proto$p$5,
      from_proto_exn: from_proto_exn$5,
      from_json_exn: from_json_exn$5
    });

const ZxReportTaxOperation = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report.ml",
      1594,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name$6(param) {
  return ".buhta.kassa.v1alpha1.ZxReportTax.ZxReportTaxOperation";
}

function make$6(operation_typeOpt, turnover_amountOpt, tax_amountOpt, param) {
  const operation_type = operation_typeOpt !== undefined ? operation_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0);
  const turnover_amount = turnover_amountOpt !== undefined ? turnover_amountOpt : "";
  const tax_amount = tax_amountOpt !== undefined ? tax_amountOpt : "";
  return {
          operation_type: operation_type,
          turnover_amount: turnover_amount,
          tax_amount: tax_amount
        };
}

const merge_operation_type$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "operation_type",
            "operationType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0)
        ]));

const merge_turnover_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "turnover_amount",
            "turnoverAmount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_tax_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "tax_amount",
            "taxAmount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$6(t1, t2) {
  return {
          operation_type: Curry._2(merge_operation_type$3, t1.operation_type, t2.operation_type),
          turnover_amount: Curry._2(merge_turnover_amount, t1.turnover_amount, t2.turnover_amount),
          tax_amount: Curry._2(merge_tax_amount, t1.tax_amount, t2.tax_amount)
        };
}

function spec$6(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "operation_type",
                    "operationType"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType),
                  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "turnover_amount",
                        "turnoverAmount"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "tax_amount",
                            "taxAmount"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
    });

function to_proto$p$6(writer, param) {
  Curry._4(serialize$6, writer, param.operation_type, param.turnover_amount, param.tax_amount);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(operation_type, turnover_amount, tax_amount) {
  return {
          operation_type: operation_type,
          turnover_amount: turnover_amount,
          tax_amount: tax_amount
        };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
    });

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$6, writer);
            });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ZxReportTax.ZxReportTaxOperation", spec$6(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.operation_type, param.turnover_amount, param.tax_amount);
  };
}

function constructor$13(operation_type, turnover_amount, tax_amount) {
  return {
          operation_type: operation_type,
          turnover_amount: turnover_amount,
          tax_amount: tax_amount
        };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ZxReportTax.ZxReportTaxOperation", spec$6(undefined), constructor$13);
    });

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$6, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ZxReportTaxOperation, {
      make: make$6,
      to_proto: to_proto$6,
      from_proto: from_proto$6,
      to_json: to_json$6,
      from_json: from_json$6,
      name: name$6,
      merge: merge$6,
      to_proto$p: to_proto$p$6,
      from_proto_exn: from_proto_exn$6,
      from_json_exn: from_json_exn$6
    });

function name$7(param) {
  return ".buhta.kassa.v1alpha1.ZxReportTax";
}

function make$7(tax_typeOpt, percentOpt, operationsOpt, param) {
  const tax_type = tax_typeOpt !== undefined ? tax_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType.from_int_exn, 0);
  const percent = percentOpt !== undefined ? percentOpt : "";
  const operations = operationsOpt !== undefined ? operationsOpt : /* [] */0;
  return {
          tax_type: tax_type,
          percent: percent,
          operations: operations
        };
}

const merge_tax_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "tax_type",
            "taxType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType.from_int_exn, 0)
        ]));

const merge_percent = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "percent",
            "percent"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_operations$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            3,
            "operations",
            "operations"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ZxReportTaxOperation.name,
                make: ZxReportTaxOperation.make,
                from_proto: ZxReportTaxOperation.from_proto,
                from_proto_exn: ZxReportTaxOperation.from_proto_exn,
                to_proto: ZxReportTaxOperation.to_proto,
                to_proto$p: ZxReportTaxOperation.to_proto$p,
                merge: ZxReportTaxOperation.merge,
                to_json: ZxReportTaxOperation.to_json,
                from_json_exn: ZxReportTaxOperation.from_json_exn,
                from_json: ZxReportTaxOperation.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$7(t1, t2) {
  return {
          tax_type: Curry._2(merge_tax_type, t1.tax_type, t2.tax_type),
          percent: Curry._2(merge_percent, t1.percent, t2.percent),
          operations: Curry._2(merge_operations$1, t1.operations, t2.operations)
        };
}

function spec$7(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "tax_type",
                    "taxType"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType),
                  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "percent",
                        "percent"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                          [
                            3,
                            "operations",
                            "operations"
                          ],
                          Ocaml_protoc_plugin__Spec.message({
                                name: ZxReportTaxOperation.name,
                                make: ZxReportTaxOperation.make,
                                from_proto: ZxReportTaxOperation.from_proto,
                                from_proto_exn: ZxReportTaxOperation.from_proto_exn,
                                to_proto: ZxReportTaxOperation.to_proto,
                                to_proto$p: ZxReportTaxOperation.to_proto$p,
                                merge: ZxReportTaxOperation.merge,
                                to_json: ZxReportTaxOperation.to_json,
                                from_json_exn: ZxReportTaxOperation.from_json_exn,
                                from_json: ZxReportTaxOperation.from_json
                              }),
                          Ocaml_protoc_plugin__Spec.not_packed
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
    });

function to_proto$p$7(writer, param) {
  Curry._4(serialize$7, writer, param.tax_type, param.percent, param.operations);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$14(tax_type, percent, operations) {
  return {
          tax_type: tax_type,
          percent: percent,
          operations: operations
        };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
    });

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$7, writer);
            });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ZxReportTax", spec$7(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.tax_type, param.percent, param.operations);
  };
}

function constructor$15(tax_type, percent, operations) {
  return {
          tax_type: tax_type,
          percent: percent,
          operations: operations
        };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ZxReportTax", spec$7(undefined), constructor$15);
    });

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$7, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportTaxOperation"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ZxReportTax, {
      ZxReportTaxOperation: ZxReportTaxOperation,
      make: make$7,
      to_proto: to_proto$7,
      from_proto: from_proto$7,
      to_json: to_json$7,
      from_json: from_json$7,
      name: name$7,
      merge: merge$7,
      to_proto$p: to_proto$p$7,
      from_proto_exn: from_proto_exn$7,
      from_json_exn: from_json_exn$7
    });

function name$8(param) {
  return ".buhta.kassa.v1alpha1.ZxReportMoneyPlacement";
}

function make$8(placement_typeOpt, countOpt, count_offlineOpt, count_totalOpt, amountOpt, param) {
  const placement_type = placement_typeOpt !== undefined ? placement_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.MoneyPlacementType.from_int_exn, 0);
  const count = countOpt !== undefined ? countOpt : 0;
  const count_offline = count_offlineOpt !== undefined ? count_offlineOpt : 0;
  const count_total = count_totalOpt !== undefined ? count_totalOpt : 0;
  const amount = amountOpt !== undefined ? amountOpt : "";
  return {
          placement_type: placement_type,
          count: count,
          count_offline: count_offline,
          count_total: count_total,
          amount: amount
        };
}

const merge_placement_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "placement_type",
            "placementType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.MoneyPlacementType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.MoneyPlacementType.from_int_exn, 0)
        ]));

const merge_count$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "count",
            "count"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_count_offline$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "count_offline",
            "countOffline"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_count_total$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "count_total",
            "countTotal"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_amount$4 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "amount",
            "amount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$8(t1, t2) {
  return {
          placement_type: Curry._2(merge_placement_type, t1.placement_type, t2.placement_type),
          count: Curry._2(merge_count$3, t1.count, t2.count),
          count_offline: Curry._2(merge_count_offline$1, t1.count_offline, t2.count_offline),
          count_total: Curry._2(merge_count_total$1, t1.count_total, t2.count_total),
          amount: Curry._2(merge_amount$4, t1.amount, t2.amount)
        };
}

function spec$8(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "placement_type",
                    "placementType"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.MoneyPlacementType),
                  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.MoneyPlacementType.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "count",
                        "count"
                      ],
                      Ocaml_protoc_plugin__Spec.int32_int,
                      0
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "count_offline",
                            "countOffline"
                          ],
                          Ocaml_protoc_plugin__Spec.int32_int,
                          0
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "count_total",
                                "countTotal"
                              ],
                              Ocaml_protoc_plugin__Spec.int32_int,
                              0
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    5,
                                    "amount",
                                    "amount"
                                  ],
                                  Ocaml_protoc_plugin__Spec.string,
                                  ""
                                ]), Ocaml_protoc_plugin__Spec.nil)))));
}

const serialize$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$8(undefined));
    });

function to_proto$p$8(writer, param) {
  Curry._6(serialize$8, writer, param.placement_type, param.count, param.count_offline, param.count_total, param.amount);
}

function to_proto$8(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$8(writer, t);
  return writer;
}

function constructor$16(placement_type, count, count_offline, count_total, amount) {
  return {
          placement_type: placement_type,
          count: count,
          count_offline: count_offline,
          count_total: count_total,
          amount: amount
        };
}

const from_proto_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$8(undefined), constructor$16);
    });

function from_proto$8(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$8, writer);
            });
}

function to_json$8(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ZxReportMoneyPlacement", spec$8(undefined))(options);
  return function (param) {
    return Curry._5(serialize, param.placement_type, param.count, param.count_offline, param.count_total, param.amount);
  };
}

function constructor$17(placement_type, count, count_offline, count_total, amount) {
  return {
          placement_type: placement_type,
          count: count,
          count_offline: count_offline,
          count_total: count_total,
          amount: amount
        };
}

const from_json_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ZxReportMoneyPlacement", spec$8(undefined), constructor$17);
    });

function from_json$8(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$8, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ZxReportMoneyPlacement, {
      make: make$8,
      to_proto: to_proto$8,
      from_proto: from_proto$8,
      to_json: to_json$8,
      from_json: from_json$8,
      name: name$8,
      merge: merge$8,
      to_proto$p: to_proto$p$8,
      from_proto_exn: from_proto_exn$8,
      from_json_exn: from_json_exn$8
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReport"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportSection"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportBalance"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportOperation"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportReceiptPayment"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportReceipt"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportTaxOperation"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportTax"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ZxReportMoneyPlacement"
        ]
      ]
    }, V1alpha1, {
      ZxReport: ZxReport,
      ZxReportSection: ZxReportSection,
      ZxReportBalance: ZxReportBalance,
      ZxReportOperation: ZxReportOperation,
      ZxReportReceipt: ZxReportReceipt,
      ZxReportTax: ZxReportTax,
      ZxReportMoneyPlacement: ZxReportMoneyPlacement
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReport"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportSection"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportBalance"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportOperation"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportReceiptPayment"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportReceipt"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportTaxOperation"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportTax"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ZxReportMoneyPlacement"
              ]
            ]
          },
          "V1alpha1"
        ]]
    }, Kassa, {
      V1alpha1: V1alpha1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReport"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportSection"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportBalance"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportOperation"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "ZxReportReceiptPayment"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportReceipt"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "ZxReportTaxOperation"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportTax"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ZxReportMoneyPlacement"
                    ]
                  ]
                },
                "V1alpha1"
              ]]
          },
          "Kassa"
        ]]
    }, Buhta, {
      Kassa: Kassa
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
